import React from 'react';
import Grid from '../../Grid';
import AccessCodeOnlyForm from '../../StudentIdForm/AccessCodeOnlyForm';
import useQueryString from '../../../hooks/use-query-string';
import AnotherStudentForm from '../../StudentIdForm/AnotherStudentForm';

const StudentIdEntry = () => {
  const { order } = useQueryString();

  return (
    <Grid container justify="center">
      <Grid item xs={11}>
        {(order !== 'yearbook_order' && order !== 'panorama') && <AccessCodeOnlyForm />}
        {(order === 'yearbook_order' || order === 'panorama') && <AnotherStudentForm />}
      </Grid>
    </Grid>
  );
};

export default StudentIdEntry;
